
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/--roboneo/studio",
      function () {
        return require("private-next-pages/--roboneo/studio/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/--roboneo/studio"])
      });
    }
  